"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UsageMeter_1 = require("./UsageMeter");
exports.default = UsageMeter_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/UsageMeter/index.js
// module id = 1832
// module chunks = 8